import { render, staticRenderFns } from "./KifuFormPrivate.vue?vue&type=template&id=464c7ba8&scoped=true&"
import script from "./KifuFormPrivate.vue?vue&type=script&lang=js&"
export * from "./KifuFormPrivate.vue?vue&type=script&lang=js&"
import style0 from "./KifuFormPrivate.vue?vue&type=style&index=0&id=464c7ba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464c7ba8",
  null
  
)

export default component.exports